export const ALL_SECTIONS = [
    'applicant',
    'building',
    'occupancy',
    'lifeSafety',
    'security',
    'maintenance',
    'parking',
    'recreation',
    'commercialTenants',
    'subcontractors',
    'generalLiability',
    'workersComp',
    'excessUmbrella',
    'lossHistory',
    'review',
];
const AMENITY_FEATURES = [
    'pool',
    'spa',
    'playground',
    'clubhouse',
    'daycare',
    'dog-park',
];
/**
 * Given classifier answers, return the ordered list of sections that apply.
 * See docs/property/PRD.md §6.2.
 */
export function applicableSections(c) {
    const sections = [
        'applicant',
        'building',
        'occupancy',
        'lifeSafety',
        'security',
        'maintenance',
        'parking',
    ];
    const hasAmenity = c.features.some((f) => AMENITY_FEATURES.includes(f));
    if (hasAmenity)
        sections.push('recreation');
    if (c.features.includes('commercial-tenants')) {
        sections.push('commercialTenants');
    }
    sections.push('subcontractors');
    if (c.coverages.includes('gl'))
        sections.push('generalLiability');
    if (c.coverages.includes('wc') && c.employees !== 'none') {
        sections.push('workersComp');
    }
    if (c.coverages.includes('umbrella'))
        sections.push('excessUmbrella');
    sections.push('lossHistory', 'review');
    return sections;
}
/**
 * Given classifier answers, return the PDF template ids that should be
 * generated on submit. Zachary internal supps (nbq, habitational) and the
 * parent ACORD (125) are always produced.
 */
export function applicableTemplates(c) {
    const templates = ['nbq', 'habitational', 'acord-125'];
    if (c.coverages.includes('property'))
        templates.push('acord-140');
    if (c.coverages.includes('gl'))
        templates.push('acord-126');
    if (c.coverages.includes('wc') && c.employees !== 'none') {
        templates.push('acord-130');
    }
    if (c.coverages.includes('umbrella'))
        templates.push('acord-131');
    return templates;
}
/**
 * Classifier whose `portfolioScope === 'multiple'` should be short-circuited
 * to the broker-contact flow; their section list is empty.
 */
export function shouldRouteToBroker(c) {
    return c.portfolioScope === 'multiple' || c.tivBucket === '100M+';
}
//# sourceMappingURL=classifier.js.map